import React from "react";
import { SectionTitle, Highlight, Prose, Reveal, PETROL } from "@/components/home/homeUi";

const PILLARS = ["Rálátás.", "Mélyebb érzékelés.", "Új választások.", "Tudatos építés."];

export default function HomeForrasKod() {
  return (
    <section
      id="forras-kod"
      data-testid="home-forras-kod"
      className="px-6 md:px-10 py-10 md:py-14 bg-tinted border-t border-hairline"
    >
      <SectionTitle testId="home-forras-kod-title" className="mb-7 md:mb-8">
        A Forrás-Kód<sup className="text-gold text-[0.45em] align-super">®</sup> kísérés
        <br />
        <em className="text-gold" style={{ fontStyle: "italic" }}>
          a felszín mögött rejlő lehetőségek
        </em>
      </SectionTitle>
      <Highlight className="mb-7 md:mb-8" testId="home-forras-kod-question">
        Mi lenne, ha az életedben visszatérő helyzetek nem csupán problémák lennének,
        hanem lehetőségek arra, hogy egészen új nézőpontból ismerd meg önmagad?
      </Highlight>
      <Prose>
        <p data-testid="home-forras-kod-body">
          A Forrás-Kód kísérés során a felszínen megjelenő élethelyzetek mögé tekintünk. A közös folyamatban figyelmet kapnak azok a mélyebb összefüggések, amelyek a gondolatainkban, érzelmeinkben, testi érzeteinkben, döntéseinkben és emberi kapcsolódásainkban megmutatkoznak. A munkám során intuitív, energetikai és önismereti megközelítéseket kapcsolok össze, miközben a folyamatot a saját érzékelésedhez, felismeréseidhez és aktuális élethelyzetedhez igazítjuk. A cél nem pusztán az, hogy felismerjünk egy működést, hanem az is, hogy új lehetőségeket nyissunk a tudatos választásra, a belső rendeződésre és a tisztább kapcsolódásra.
        </p>
      </Prose>
      <Highlight className="mt-7 md:mt-9" testId="home-forras-kod-highlight">
        Nem egy előre meghatározott életutat szeretnék megmutatni, hanem teret nyitni
        annak, hogy a saját utadat egyre tisztábban érzékeld.
      </Highlight>
      <Reveal className="mt-9 md:mt-10 max-w-4xl mx-auto">
        <ul
          data-testid="home-forras-kod-pillars"
          className="grid grid-cols-2 md:grid-cols-4"
          style={{ borderTop: `1px solid ${PETROL}33`, borderBottom: `1px solid ${PETROL}33` }}
        >
          {PILLARS.map((p, i) => (
            <li
              key={p}
              className={`py-6 md:py-7 px-3 text-center font-serif-display text-[19px] md:text-[22px] text-graphite ${
                i > 0 ? "md:border-l" : ""
              } ${i % 2 === 1 ? "border-l md:border-l" : ""} ${i > 1 ? "border-t md:border-t-0" : ""}`}
              style={{ borderColor: `${PETROL}26` }}
            >
              <span className={i % 2 === 1 ? "italic text-gold" : ""}>{p}</span>
            </li>
          ))}
        </ul>
      </Reveal>
    </section>
  );
}
